import MaskPlugin from '@vueform/plugin-mask';
import { defineConfig } from '@vueform/vueform';
import { Validator } from '@vueform/vueform';
import tailwind from '@vueform/vueform/dist/tailwind';
import en from '@vueform/vueform/locales/en';
import fr from '@vueform/vueform/locales/fr';
import ja from '@vueform/vueform/locales/ja';
import zh_CN from '@vueform/vueform/locales/zh_CN';

import enTranslations from '@/assets/translations/en/common.json' with { type: 'json' };
import frTranslations from '@/assets/translations/fr/common.json' with { type: 'json' };
import jaTranslations from '@/assets/translations/ja/common.json' with { type: 'json' };
import zhCnTranslations from '@/assets/translations/zh-cn/common.json' with { type: 'json' };

// Set custom validation errors
const frErrors = frTranslations.errors.fields;
for (const field in frErrors) {
  fr.validation[field] = frErrors[field as keyof typeof frErrors];
}
const enErrors = enTranslations.errors.fields;
for (const field in enErrors) {
  en.validation[field] = enErrors[field as keyof typeof enErrors];
}
const jaErrors = jaTranslations.errors.fields;
for (const field in jaErrors) {
  ja.validation[field] = jaErrors[field as keyof typeof jaErrors];
}
const zhCnErrors = zhCnTranslations.errors.fields;
for (const field in zhCnErrors) {
  zh_CN.validation[field] = zhCnErrors[field as keyof typeof zhCnErrors];
}

class urlWithDefault extends Validator {
  check(value: string) {
    if (value === 'https://') {
      return true;
    }

    // We use the default VueForm's url validation
    // https://gist.github.com/dperini/729294
    var regex = new RegExp(
      '^' +
        // protocol identifier (optional)
        // short syntax // still required
        '(?:(?:(?:https?|ftp):)?\\/\\/)' +
        // user:pass BasicAuth (optional)
        '(?:\\S+(?::\\S*)?@)?' +
        '(?:' +
        // IP address exclusion
        // private & local networks
        '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
        '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
        '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
        // IP address dotted notation octets
        // excludes loopback network 0.0.0.0
        // excludes reserved space >= 224.0.0.0
        // excludes network & broacast addresses
        // (first & last IP address of each class)
        '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
        '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
        '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
        '|' +
        // host & domain names, may end with dot
        // can be replaced by a shortest alternative
        // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
        '(?:' +
        '(?:' +
        '[a-z0-9\\u00a1-\\uffff]' +
        '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
        ')?' +
        '[a-z0-9\\u00a1-\\uffff]\\.' +
        ')+' +
        // TLD identifier name, may end with dot
        '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
        ')' +
        // port number (optional)
        '(?::\\d{2,5})?' +
        // resource path (optional)
        '(?:[/?#]\\S*)?' +
        '$',
      'i'
    );

    return regex.test(value);
  }
}

export default defineConfig({
  theme: tailwind,
  locales: { en, fr, ja, ['zh-cn']: zh_CN },
  locale: 'en',
  floatPlaceholders: false,
  plugins: [MaskPlugin],
  rules: {
    urlWithDefault
  }
});
